import { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Button } from "@/components/ui/button";
import { Copy } from "lucide-react";
import { toast } from "sonner";
import { LANGUAGES, type Language } from "@/snippets";

interface TabbedCodeBlockProps {
  snippets: Record<Language, string>;
  defaultLanguage?: Language;
}

export function TabbedCodeBlock({ snippets, defaultLanguage = "python" }: TabbedCodeBlockProps) {
  const [language, setLanguage] = useState<Language>(defaultLanguage);

  return (
    <Tabs value={language} onValueChange={(v) => setLanguage(v as Language)} className="min-w-0">
      <div className="flex items-center justify-between mb-2 gap-1">
        <TabsList className="flex-1 min-w-0 overflow-x-auto">
          {LANGUAGES.map(({ value, label }) => (
            <TabsTrigger key={value} value={value} className="text-xs">
              {label}
            </TabsTrigger>
          ))}
        </TabsList>
        <Button
          size="sm"
          variant="ghost"
          className="h-8 px-2 text-xs text-muted-foreground hover:text-foreground shrink-0"
          onClick={() => {
            navigator.clipboard.writeText(snippets[language]);
            toast.success("Copied to clipboard");
          }}
        >
          <Copy className="h-3.5 w-3.5 sm:mr-1.5" />
          <span className="hidden sm:inline">Copy</span>
        </Button>
      </div>
      {LANGUAGES.map(({ value }) => (
        <TabsContent key={value} value={value} className="mt-0">
          <pre className="bg-muted text-foreground p-4 rounded-lg overflow-x-auto text-sm font-mono border border-border">
            <code>{snippets[value]}</code>
          </pre>
        </TabsContent>
      ))}
    </Tabs>
  );
}
